import cloneDeep from 'lodash/cloneDeep';
import type { BoardState, GridPosition } from '../../../game/boardMVC/types';

export function applyDiagonalSymmetry(originalBoard: BoardState): BoardState {
  const symmetricalBoard = cloneDeep(originalBoard);

  // board needs to have 2x the cols then rows
  if (symmetricalBoard.cols < symmetricalBoard.rows * 2) {
    symmetricalBoard.cols = symmetricalBoard.rows * 2;
  }

  const { cols, rows } = symmetricalBoard;
  const midX = Math.round(cols / 2);

  const getReflectedEntries = <T extends GridPosition>(collection: T[]): T[] => {
    const output: T[] = [];
    collection.forEach((stack) => {
      const colOffset = Math.floor(stack.x / 2);

      if (colOffset > stack.y || (colOffset === stack.y && stack.x >= midX)) {
        return;
      }

      output.push(
        {
          ...stack,
        },
        {
          ...stack,
          x: cols - stack.x - 1,
          y: rows - stack.y - 1,
        },
      );
    });
    return output;
  };

  return {
    ...symmetricalBoard,
    stacks: getReflectedEntries(symmetricalBoard.stacks),
    hiddenStacks: getReflectedEntries(symmetricalBoard.hiddenStacks),
    blockers: getReflectedEntries(symmetricalBoard.blockers ?? []),
  };
}
